import { Box, Image } from '@chakra-ui/react'
import React from 'react'

const loadingProp =
  process.env.NEXT_PUBLIC_SIMPLIFY_IMAGE_COMPONENT === 'true' ? 'eager' : 'lazy'

export const GatsbyImage = ({
  responsive,
  image,
  className = '',
  layout = 'responsive',
  ...props
}) => {
  if (!image) {
    console.error(
      'In GatsbyImage, `image` prop is required but it was not specified'
    )
    return null
  }
  if (responsive) {
    const keys = Object.keys(image)
    const defaultDisplay = keys.reduce((obj, key) => {
      obj[key] = 'none'
      return obj
    }, {})
    return keys.map((key, index) => {
      console.log("iiiiiiiiiiiiii", image[key]);
      
      return (
        <Box
          display={{ ...defaultDisplay, [key]: 'block' }}
          key={index}
          className={className}
        >
          <Image
            position={'absolute'}
            src={image[key]}
            layout={layout}
            loading={loadingProp}
            {...props}
          />
        </Box>
      )
    })
  } else {
    return (
      <Image src={image} layout={layout} loading={loadingProp} {...props} />
    )
  }
}

export const GatsbyBgImage = ({
  image,
  position = 'center center',
  objectFit = 'cover',
  responsive = false,
  zIndex = -1,
  ...props
}) => {
  return (
    <Box
      position={'absolute'}
      top={0}
      bottom={0}
      left={0}
      right={0}
      sx={{ zIndex }}
    >
      <GatsbyImage
        responsive={responsive}
        image={image}
        objectFit={objectFit}
        objectPosition={position}
        layout={'fill'}
        {...props}
      />
    </Box>
  )
}